export enum MbbDeliveryOptions {
  SellInStore = 'SellInStore',
  SendRouterInPost = 'SendRouterInPost',
  AlreadyOwnRouter = 'AlreadyOwnRouter',
}
